import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const directDebitManage_KRAKEN: IMcAppType = {
  name: "directDebitManage_KRAKEN",
  path: "/my/direct-debit",
  description: "Manage Direct Debit",
  navFlow: NavFlow.STANDARD,
  title: "Direct debit",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410

  conditions: {
    intent: "directDebitManage",
    customerType: CustomerType.kraken,
  },
};
